"use client";

import { EyeIcon, EyeOffIcon } from "lucide-react";
import React from "react";
import { useState } from "react";

interface PasswordToggleWrapperProps {
  children: React.ReactNode;
}

export const PasswordToggleWrapper = ({
  children,
}: PasswordToggleWrapperProps) => {
  const [eyeOn, setEyeOn] = useState(false);

  const handleClick = () => {
    setEyeOn((prev) => !prev);
  };

  return (
    <div className="relative">
      {React.Children.map(children, (child) => {
        // Clone the child element and pass the updated type prop
        return React.cloneElement(child as React.ReactElement, {
          type: eyeOn ? "text" : "password",
        });
      })}
      <div
        className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-[#888891]"
        onClick={handleClick}
      >
        {eyeOn ? <EyeIcon /> : <EyeOffIcon />}
      </div>
    </div>
  );
};
